import React from 'react';
import { avatarClass, initials } from './designHelpers';

export default function Avatar({ name, size }) {
  return (
    <span className={`mtn-avatar ${avatarClass(name)}${size === 'sm' ? ' mtn-avatar-sm' : ''}`}>
      {initials(name)}
    </span>
  );
}
